import I18n from 'i18n-js';
import { string } from 'prop-types';

import BottomPopupWithTransition from '~/components/BottomPopupWithTransition';
import Body from '~/components/DailyTasksView/DailyRewardPopupsBody';

import useBooleanState from '~/hooks/useBooleanState';

import info from '~/assets/images/iconsLibrary/info.svg';

import style from './DailyInfo.module.scss';

export default function DailyInfo({ popupGradient }) {
  const [show, toggleShow] = useBooleanState();

  return (
    <section className={style.dailyInfo}>
      <h2 className={style.header}>
        {I18n.t('DailyView_weekly_route_headline')}
      </h2>
      <img
        src={info}
        alt="check"
        onClick={toggleShow}
        className={style.img}
      />
      <BottomPopupWithTransition
        banner={I18n.t('DailyView_bc')}
        body={
          <Body
            description={I18n.t('DailyView_weekly_info')}
            title={I18n.t('DailyView_weekly_info_headline')}
          />
        }
        closeButtonEnabled
        onClose={toggleShow}
        show={show}
        style={{ background: `linear-gradient(${popupGradient})` }}
      />
    </section>
  );
}

DailyInfo.propTypes = {
  popupGradient: string.isRequired,
};
